import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.object.define-property.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, useUrlParams, RangePicker, Button, FundsDepositForm } from 'components';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FundsDepositsTableHeader = function FundsDepositsTableHeader(_ref) {
  var getData = _ref.getData,
      canViewForm = _ref.canViewForm,
      onDeposit = _ref.onDeposit,
      onExport = _ref.onExport,
      label = _ref.label,
      placeholder = _ref.placeholder,
      addButtonText = _ref.addButtonText,
      takeButtonText = _ref.takeButtonText;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var startDate = urlQueryParams.startDate,
      endDate = urlQueryParams.endDate;
  var queryParams = useRef(urlQueryParams);
  useEffect(function () {
    getData(queryParams.current);
  }, []);

  var handleDateChange = function handleDateChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDate: startDate,
      endDate: endDate
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8,
    align: "center",
    justify: "space-between"
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: "auto"
  }, _isFunction(onExport) && ___EmotionJSX(Button, {
    margin: "0 0 1em 0",
    small: true,
    type: "secondary",
    onClick: onExport,
    leftIcon: {
      iconName: 'la la-file-excel',
      size: 20
    }
  }), ___EmotionJSX(RangePicker, {
    label: "\u0414\u0430\u0442\u0430",
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: startDate,
    endDate: endDate,
    onChange: handleDateChange
  })), canViewForm && ___EmotionJSX(Col, {
    sm: 12,
    md: "auto"
  }, ___EmotionJSX(FundsDepositForm, {
    label: label,
    placeholder: placeholder,
    onDeposit: onDeposit,
    addButtonText: addButtonText,
    takeButtonText: takeButtonText
  }))));
};

FundsDepositsTableHeader.propTypes = {
  getData: PropTypes.func,
  onDeposit: PropTypes.func,
  onExport: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  addButtonText: PropTypes.string,
  takeButtonText: PropTypes.string,
  canViewForm: PropTypes.bool
};
export default FundsDepositsTableHeader;